export default "__VITE_ASSET__bbc16cea__"